import {
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,

  PATCH_CLINIC_IMAGE_REQUEST,
  PATCH_CLINIC_IMAGE_SUCCESS,
  PATCH_CLINIC_IMAGE_FAIL,

  UPDATE_SERVICES_REQUEST,
  UPDATE_SERVICES_SUCCESS,
  UPDATE_SERVICES_FAIL,

  UPDATE_SPECIALIZATION_REQUEST,
  UPDATE_SPECIALIZATION_SUCCESS,
  UPDATE_SPECIALIZATION_FAIL,

  UPDATE_EDUCATION_REQUEST,
  UPDATE_EDUCATION_SUCCESS,
  UPDATE_EDUCATION_FAIL,

  UPDATE_EXPERIENCE_REQUEST,
  UPDATE_EXPERIENCE_SUCCESS,
  UPDATE_EXPERIENCE_FAIL,

  UPDATE_AWARDS_REQUEST,
  UPDATE_AWARDS_SUCCESS,
  UPDATE_AWARDS_FAIL,

  UPDATE_MEMBERSHIPS_REQUEST,
  UPDATE_MEMBERSHIPS_SUCCESS,
  UPDATE_MEMBERSHIPS_FAIL,

  UPDATE_REGISTRATIONS_REQUEST,
  UPDATE_REGISTRATIONS_SUCCESS,
  UPDATE_REGISTRATIONS_FAIL,
} from '../actions/types';

const initialState = {
  loading: false,
  error: null,
  profileInfo: {},
  clinicImage: {},
  services: [],
  specialization: [],
  education: [],
  experience: [],
  awards: [],
  memberships: [],
  registrations: [],
};

export const updatedoctorProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_REQUEST:
    case PATCH_CLINIC_IMAGE_REQUEST:
    case UPDATE_SERVICES_REQUEST:
    case UPDATE_SPECIALIZATION_REQUEST:
    case UPDATE_EDUCATION_REQUEST:
    case UPDATE_EXPERIENCE_REQUEST:
    case UPDATE_AWARDS_REQUEST:
    case UPDATE_MEMBERSHIPS_REQUEST:
    case UPDATE_REGISTRATIONS_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        profileInfo: {
          ...state.profileInfo,
          ...action.payload,  // merge updated profile fields here
        },
        error: null,
      };

    case PATCH_CLINIC_IMAGE_SUCCESS:
      return { ...state, loading: false, clinicImage: action.payload };

    case UPDATE_SERVICES_SUCCESS:
      return { ...state, loading: false, services: action.payload };

    case UPDATE_SPECIALIZATION_SUCCESS:
      return { ...state, loading: false, specialization: action.payload };

    case UPDATE_EDUCATION_SUCCESS:
      return { ...state, loading: false, education: action.payload };

    case UPDATE_EXPERIENCE_SUCCESS:
      return { ...state, loading: false, experience: action.payload };

    case UPDATE_AWARDS_SUCCESS:
      return { ...state, loading: false, awards: action.payload };

    case UPDATE_MEMBERSHIPS_SUCCESS:
      return { ...state, loading: false, memberships: action.payload };

    case UPDATE_REGISTRATIONS_SUCCESS:
      return { ...state, loading: false, registrations: action.payload };

    case UPDATE_PROFILE_FAIL:
    case PATCH_CLINIC_IMAGE_FAIL:
    case UPDATE_SERVICES_FAIL:
    case UPDATE_SPECIALIZATION_FAIL:
    case UPDATE_EDUCATION_FAIL:
    case UPDATE_EXPERIENCE_FAIL:
    case UPDATE_AWARDS_FAIL:
    case UPDATE_MEMBERSHIPS_FAIL:
    case UPDATE_REGISTRATIONS_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
